<form [formGroup]="applicationKeysForm">
  <div class="row">
    <label class="col-sm-2 col-form-label-sm">
      OAuth 2.0 Keys
    </label>
    <div class="col-sm-10">
      <table class="table table-bordered table-sm">
        <thead class="thead-light">
        <th>
          Key Type
        </th>
        <th>
          Consumer Key
        </th>
        <th>
          Consumer Secret
        </th>
        <!--<th>-->
        <!--Callback URL-->
        <!--</th>-->
        </thead>
        <tbody>
        <tr *ngFor="let key of keysAvailable">
          <td>{{key.keyType | titlecase}}</td>
          <td>{{key.consumerKey}}</td>
          <td>{{key.consumerSecret}}</td>
          <!--<td>{{key.callbackUrl}}</td>-->
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <hr class="mt-3 mb-2">
  <h2>
    API Runtime
  </h2>
  <div class="row mb-2">
    <label class="col-sm-2 col-form-label-sm">
      Token API Call
    </label>
    <div class="col-sm-10 ">
      <div class="form-inline">
        <div class="form-group mb-2">
          <label class="col-form-label-sm"
                 style="font-weight: normal"
                 for="keyItemSelected">
            Key Type
          </label>
          <select id="keyItemSelected"
                  class="form-control form-control-sm ml-1"
                  formControlName="keyItemSelected"
                  (change)="generateAccessToken(false, true, false)">
            <option *ngFor="let key of keysAvailable"
                    [ngValue]="key">
              {{key.keyType | titlecase}}
            </option>
          </select>
        </div>
        <div class="form-group ml-3 mb-2">
          <label class="col-form-label-sm"
                 style="font-weight: normal"
                 for="grantTypeSelected">
            Grant Type
          </label>
          <select id="grantTypeSelected"
                  class="form-control form-control-sm ml-1"
                  formControlName="grantTypeSelected"
                  (change)="generateAccessToken(false, false, true)">
            <option *ngFor="let grantType of grantTypesAvailable"
                    [ngValue]="grantType">
              {{grantType.name}}
            </option>
          </select>
          <label class="col-form-label-sm ml-2"
                 style="font-weight: normal"
                 for="grantTypeUser"
                 *ngIf="applicationKeysForm.value.grantTypeSelected.requiresUserAndPassword">
            User
          </label>
          <input id="grantTypeUser"
                 class="form-control form-control-sm ml-1"
                 type="text"
                 *ngIf="applicationKeysForm.value.grantTypeSelected.requiresUserAndPassword"
                 formControlName="grantTypeUser"
                 (keypress)="tokenApiCallGrantTypeChanged()">
          <label class="col-form-label-sm ml-2"
                 style="font-weight: normal"
                 for="grantTypePassword"
                 *ngIf="applicationKeysForm.value.grantTypeSelected.requiresUserAndPassword">
            Password
          </label>
          <input id="grantTypePassword"
                 class="form-control form-control-sm ml-1"
                 type="password"
                 *ngIf="applicationKeysForm.value.grantTypeSelected.requiresUserAndPassword"
                 formControlName="grantTypePassword"
                 (keypress)="tokenApiCallGrantTypeChanged()">
          <label class="col-form-label-sm ml-2"
                 style="font-weight: normal"
                 for="grantTypeRefreshToken"
                 *ngIf="applicationKeysForm.value.grantTypeSelected.requiresRefreshToken">
            Refresh Token
          </label>
          <input id="grantTypeRefreshToken"
                 class="form-control form-control-sm ml-1"
                 type="text"
                 *ngIf="applicationKeysForm.value.grantTypeSelected.requiresRefreshToken"
                 formControlName="grantTypeRefreshToken"
                 (keypress)="tokenApiCallGrantTypeChanged()">
        </div>
      </div>

      <div class="grey lighten-4 p-2">

        <div class="text-right">
          <button class="btn btn-xs btn-light aqx-application-keys-btn-xs ml-3"
                  type="button"
                  mdbBtn
                  mdbWavesEffect
                  mdbPopoverHeader="Generate Access Token"
                  mdbPopover="Execute the curl command to re-generate an access token."
                  triggers="hover"
                  [disabled]="generatingAccessToken ||
                    (applicationKeysForm.value.grantTypeSelected.requiresRefreshToken && !applicationKeysForm.value.grantTypeRefreshToken) ||
                    (applicationKeysForm.value.grantTypeSelected.requiresUserAndPassword && (!applicationKeysForm.value.grantTypeUser || !applicationKeysForm.value.grantTypePassword))"
                  (click)="generateAccessToken(true)">

            <i class="fas fa-bolt"
               style="color: darkgoldenrod;"></i>
            Generate
            <i class="fa fa-spin fa-spinner"
               *ngIf="generatingAccessToken">
            </i>

          </button>
          <button class="btn btn-xs btn-light aqx-application-keys-btn-xs ml-3"
                  type="button"
                  mdbBtn
                  mdbWavesEffect
                  mdbPopoverHeader="Copy Token API Call"
                  mdbPopover="Copy the curl command to generate an access token. You can then Paste it into a command window and execute it."
                  triggers="hover"
                  [disabled]="tokenApiCallCopied"
                  (click)="copyTokenApiCall()">
            <span *ngIf="!tokenApiCallCopied">
              <i class="far fa-copy"></i>
              Copy
            </span>
            <span class="ml-1"
                   *ngIf="tokenApiCallCopied">
              Copied.
            </span>

          </button>
        </div>

<pre>
curl {{oauthTokenUri}}<span *ngIf="oauthTokenUriHasPort"> -k</span> \
     -u<!--
--><span style="display: inline-block;"
         [ngClass]="{'animated fadeIn': tokenApiCallKeyTypeChange}"><!--
--> {{applicationKeysForm.value.keyItemSelected.consumerKey}}:{{applicationKeysForm.value.keyItemSelected.consumerSecret}} \<!--
--></span><!--
--><div><!--
-->     <span style="display: inline-block;vertical-align: top;">-d "grant_type=</span><!--
--><span style="display: inline-block;"
         [ngClass]="{'animated fadeIn': tokenApiCallGrantTypeChange}">{{applicationKeysForm.value.grantTypeSelected.name}}<!--
--><span *ngIf="!applicationKeysForm.value.grantTypeSelected.requiresUserAndPassword && !applicationKeysForm.value.grantTypeSelected.requiresRefreshToken">"</span><!--
--><span *ngIf="applicationKeysForm.value.grantTypeSelected.requiresUserAndPassword"><!--
-->&username={{applicationKeysForm.value.grantTypeUser || '$USERNAME'}}&password={{applicationKeysForm.value.grantTypePassword ? '*'.repeat(applicationKeysForm.value.grantTypePassword.length) : '$PASSWORD'}}"<!--
--></span><!--
--><span *ngIf="applicationKeysForm.value.grantTypeSelected.requiresRefreshToken"><!--
-->&refresh_token={{applicationKeysForm.value.grantTypeRefreshToken || '$REFRESH_TOKEN'}}"<!--
--></span><!--
--></span><!--
--></div>
</pre>

      </div>
    </div>
  </div>
  <div class="row">
    <label class="col-sm-2 col-form-label-sm">
      Token API Response
    </label>
    <div class="col-sm-10">
      <div class="grey lighten-4 p-2">
        <pre [ngClass]="{'animated fadeIn': tokenApiResponseChange}"
             *ngIf="applicationKeysForm.value.grantTypeSelected.accessTokenResponse">
{{applicationKeysForm.value.grantTypeSelected.accessTokenResponse | json}}<!--
     --></pre>
        <div class="form-control-sm form-control-plaintext"
             *ngIf="applicationKeysForm.value.grantTypeSelected.isError">
          <i class="fas fa-exclamation-circle"></i>
          Error executing the Token API Call for Grant Type {{applicationKeysForm.value.grantTypeSelected.name}}.
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <label class="col-sm-2 col-form-label-sm">
      Base Invocation URI
    </label>
    <div class="col-sm-10">
      <div class="form-control-sm form-control-plaintext">
        {{invocationUri}}
      </div>
    </div>
  </div>
  <div class="row">
    <label class="col-sm-2 col-form-label-sm">
      Example API Call
    </label>
    <!--<code>-->
    <!--{{getExampleApiCurl()}}-->
    <!--</code>-->

    <div class="col-sm-10">
      <div class="grey lighten-4 p-2">

        <div class="text-right">
          <button class="btn btn-xs btn-light aqx-application-keys-btn-xs"
                  type="button"
                  mdbBtn
                  mdbWavesEffect
                  mdbPopover="Copy the curl command to make an example API call. You can then Paste it into a command window and execute it."
                  mdbPopoverHeader="Copy Example API Call"
                  triggers="hover"
                  [disabled]="exampleApiCallCopied"
                  (click)="copyExampleApiCall()">
            <span *ngIf="!exampleApiCallCopied">
              <i class="far fa-copy"></i>
              Copy
            </span>
            <span class="ml-1"
                   style="display: inline-block"
                   *ngIf="exampleApiCallCopied">
              Copied.
            </span>
          </button>

        </div>

<pre>
curl {{invocationUri}}{{exampleResource}}<span *ngIf="gatewayBaseUriHasPort"> -k</span> \
     -H 'Authorization: Bearer<!--
      --><span style="display: inline-block;"
            [ngClass]="{'animated fadeIn': tokenApiResponseChange}"><!--
      --> {{applicationKeysForm.value.grantTypeSelected.accessToken || '$ACCESS_TOKEN'}}<!--
      --></span>
</pre>

      </div>
    </div>
  </div>
</form>
